import { render, staticRenderFns } from "./DictionaryEnumEdit.vue?vue&type=template&id=128b615e&scoped=true&"
import script from "./DictionaryEnumEdit.vue?vue&type=script&lang=js&"
export * from "./DictionaryEnumEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128b615e",
  null
  
)

export default component.exports